
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index0vkkOtnpWYjKgRv_45tHITj_45kTvaatS7bK_B2YghY9cIIMeta } from "/tmp/tmpimoxvjzq/pages/index.vue?macro=true";
import { default as indexyjYjdF8ZYYO_45n6MnfM0cMeym7Cvq5R4r3LHU4PZQ1pAMeta } from "/tmp/tmpimoxvjzq/pages/[rvrsys]/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmpimoxvjzq/pages/index.vue")
  },
  {
    name: "rvrsys",
    path: "/:rvrsys()",
    component: () => import("/tmp/tmpimoxvjzq/pages/[rvrsys]/index.vue")
  }
]